$(document).ready(function() {
	var offset_sticky = $('.sticky-bg').offset().top;
  	var slider_offset = $('.featured-slider-container').offset().top;
  	var slider_height = $('.featured-slider-container').height();
  	var bottom_offset = slider_height + slider_offset;
  	var window_height = $(window).height();
  	sticky();
  
    var split_text_2 = isInViewport($('#split_text_2'));
  	isVisibleBg(split_text_2, $('#split-bg-2'));
    var split_text_3 = isInViewport($('#split_text_3'));
  	isVisibleBg(split_text_3, $('#split-bg-3'));
    var split_text_4 = isInViewport($('#split_text_4'));
  	isVisibleBg(split_text_4, $('#split-bg-4'));
  
  	
  
  $(window).on('resize', function(){
    var offset_sticky = $('.sticky-bg').offset().top;
  	var slider_offset = $('.featured-slider-container').offset().top;
  	var slider_height = $('.featured-slider-container').height();
  	var bottom_offset = slider_height + slider_offset;
  	var window_height = $(window).height();
    sticky();
    
    var split_text_2 = isInViewport($('#split_text_2'));
  	isVisibleBg(split_text_2, $('#split-bg-2'));
    var split_text_3 = isInViewport($('#split_text_3'));
  	isVisibleBg(split_text_3, $('#split-bg-3'));
    var split_text_4 = isInViewport($('#split_text_4'));
  	isVisibleBg(split_text_4, $('#split-bg-4'));
  });
  
  $(document).on('scroll', function(){
    
    sticky();
    
    var split_text_2 = isInViewport($('#split_text_2'));
  	isVisibleBg(split_text_2, $('#split-bg-2'));
    var split_text_3 = isInViewport($('#split_text_3'));
  	isVisibleBg(split_text_3, $('#split-bg-3'));
    var split_text_4 = isInViewport($('#split_text_4'));
  	isVisibleBg(split_text_4, $('#split-bg-4'));
  });
  
  
  
  function sticky(){
  	var scrolltop = $(window).scrollTop();
    var scrollbottom = scrolltop + window_height;
    if(offset_sticky <= scrolltop && bottom_offset >= scrollbottom){
      $('.split-2').css('margin-left', '50%' );
      $('.sticky-bg').css('position', 'fixed' );
      $('.sticky-bg').css('top', '0px');
        $('.sticky-bg').css('margin-top', '0px');
    } else {
      if(offset_sticky <= scrollbottom){
      	$('.sticky-bg').css('position', 'absolute');
        if(offset_sticky <= scrolltop){
          $('.sticky-bg').css('top', '100%');
        	$('.sticky-bg').css('margin-top', '-100vh');
        } else {
        	$('.sticky-bg').css('top', '0px');
        	$('.sticky-bg').css('margin-top', '0px');
        }
        
      } else {
      	$('.sticky-bg').css('position', 'relative' );
        $('.split-2').css('margin-left', '0px' );
      }
    }
  }
  
  
  function isVisibleBg(visible, target){
    if(visible){
    	target.fadeIn();
      	$('#split-bg-1').css('display', 'block');
    } else {
    	target.fadeOut();
      	var bottom_offset_bg_1 = offset_sticky + $('.split-1').height();
           if((!isInViewport($('#split_text_1'))) && (bottom_offset_bg_1 <= $(window).scrollTop())){
             $('#split-bg-1').fadeOut(function(){
             	$('#split-bg-1').css('display', 'none');
             });
           } else {
           	  $('#split-bg-1').fadeIn();
           }
    }
  }
  
  
  function isInViewport(target) {
    var elementTop = target.offset().top;
    var elementBottom = elementTop + target.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
});